import actions from '../../actionTypes';

export default siteId => {
  return {
    type: actions.GET_GATEWAY_DETAIL,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/getGatewayDetail.js